import * as React from 'react';
import Modal from 'antd/lib/modal';
import Button from 'antd/lib/button';
import Steps from 'antd/lib/steps';
import Input from 'antd/lib/input';
import Spin from 'antd/lib/spin';
import message from 'antd/lib/message';
import injectSheet from 'react-jss';
import CreateEnquiryDetails from '../CreateEnquiryDetails';
import ViewBreakdown from './ViewBreakdown';
import BookingFFModal from '../Booking/BookingFFModal';
import { EventCategories, sendEvent } from 'src/utils/gaService';
import { commonStyles, buttonStyle } from 'src/Library/CommonStyles';
import { connect } from 'react-redux';
import { BookingProcess, bookingStepsMap } from '../Booking/BookingUtils';
import Protip from '../Booking/Protip';
import { isValidString } from 'src/Library/Helper';
import INTTRABookingConfirmationModal from './INTTRABookingConfirmationModal';
import { bindActionCreators } from 'redux';
import { updateInttraCodeInMasterData } from 'src/actions/bookingInquiryActions';
const inttraLogo = require('src/assets/images/inttraLogo.png');
const documentUpload = require('src/assets/images/documentUpload.svg');
const docUploadDisabled = require('src/assets/images/docUploadDisabled.svg');
import classNames from 'classnames';
import { requestInttraRegistrationEmail } from 'src/api/booking';
import { InquiryModes } from 'src/Library/Constants';
import AddTruckingBookingDetails from '../Booking/AddTruckingBookingDetails';
import { tokens } from 'src/design-system';

const styles = theme => ({
  modal: {
    minWidth: '1000px',
    width: '100% !important',
    top: 0,
    '& .ant-modal-body': {
      padding: 0,
    },
  },
  cardToDiv: {
    margin: '0px',
    padding: '0px',
    '& .ant-card': {
      border: 'none',
      margin: 0,
    },
    '& .ant-card-body': {
      padding: '0px',
      border: 'none',
    },
  },
  bookingSteps: {
    backgroundColor: '#FCFCFC',
    padding: '22px 22px',
    '& .ant-steps-item-finish .ant-steps-item-icon': {
      backgroundColor: '#44D13D',
      color: tokens.colors.bgWhite,
      borderColor: tokens.colors.bgWhite,
      '& .ant-steps-icon': {
        color: tokens.colors.bgWhite,
      },
    },
    '& .ant-steps-item-title': {
      fontSize: `${tokens.fontSize.body}px`,
      fontWeight: tokens.fontWeight.semibold,
    },
  },
  processSelection: {
    ...commonStyles(theme).flexColumn,
    alignItems: 'center',
    height: '550px',
    justifyContent: 'center',
  },
  selection: {
    width: '200px',
    border: '1px solid #D9D9D9',
    borderRadius: `${tokens.radius.md}px`,
    height: '104px',
    ...commonStyles(theme).flexColumn,
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
  },
  disabledSelection: {
    cursor: 'not-allowed',
    color: '#999999',
  },
  requestCode: {
    color: '#1875F0',
    cursor: 'pointer',
    textDecoration: 'underline',
  },
  requestInttraCode: {
    fontWeight: tokens.fontWeight.semibold,
    color: tokens.colors.textSecondary,
    position: 'absolute',
    bottom: '100px',
  },
  inttraCode: {
    marginTop: '16px',
    ...commonStyles(theme).flexRow,
    fontSize: `${tokens.fontSize.small}px`,
    color: tokens.colors.textSecondary,
    width: '32%',
    fontWeight: tokens.fontWeight.semibold,
  },
  selectionText: {
    fontSize: `${tokens.fontSize.h2}px`,
    fontWeight: tokens.fontWeight.semibold,
    color: '#262626',
    textAlign: 'center',
  },
  inttraIsLive: {
    border: '1px solid #68CCB7',
    backgroundColor: '#48E4C3',
    borderRadius: `${tokens.radius.sm}px`,
    fontSize: '8px',
    color: '#000000',
    marginLeft: '6px',
    padding: '2px',
    fontWeight: 'normal',
    verticalAlign: 'top',
  },
  inttraCodeEdit: {
    backgroundColor: 'rgba(23,162,178,0.05)',
    borderRadius: '14px',
    fontSize: `${tokens.fontSize.caption}px`,
    padding: '0px 10px',
    fontWeight: 'normal',
  },
  editButton: {
    cursor: 'pointer',
    color: '#1592ED',
    fontSize: `${tokens.fontSize.caption}px`,
    marginLeft: '16px',
    fontWeight: tokens.fontWeight.semibold,
  },
  updateButton: {
    ...buttonStyle(tokens.colors.bgWhite, '#1875F0', '1px solid #1875F0'),
    marginLeft: '8px',
  },
  cancelButton: {
    ...buttonStyle('#424242', '#F2F4F6', '1px solid #DDE0E5'),
  },
  editCodeModal: {
    '& .ant-modal-body': {
      padding: '26px 24px 62px 24px',
      ...commonStyles(theme).flexRow,
    },
  },
});
class BookingDetail extends React.PureComponent<any, any> {
  state = {
    creatingBooking: false,
    viewBreakdownVisible: false,
    chargeDetails: {},
    bookingFFModalVisible: false,
    currentBookingStep: (this.props.isAmend || this.props.isCreateNew) ?
      bookingStepsMap(true).CONFIRMATION : bookingStepsMap(false).SHIPPER_BOOKING_DETAILS,
    bookingProcess: BookingProcess.INTTRA,
    inttraCode: this.props.inttraCode,
    protip: false,
    isEditINTTRACodeModalVisible: false,
    newINTTRACode: this.props.inttraCode,
    isBooking: false,
    isRequestInttraRegistrationLoading: false,
  };

  createBooking = async () => {
    sendEvent(
      EventCategories.INQUIRY_BOOKING_FF,
      'Process Booking - Updated Details Next',
    );
    this.setState({ creatingBooking: true });
    this.setState({ viewBreakdownVisible: true });
    this.incrementStepChange();
    this.setState({ creatingBooking: false });
  }

  renderFooter = (onCancel, onOk, disabled = false, isInttraConfirmation = false) => {
    const { isBooking, inttraCode } = this.state;
    const { updateInttraCodeInMasterData } = this.props;
    return <div style={{ display: 'flex', justifyContent: 'space-between' }}>
      <a style={{ color: tokens.colors.primary, fontSize: `${tokens.fontSize.h3}px` }}
        onClick={!isBooking && onCancel}>Back</a>
      <Button
        loading={this.state.creatingBooking}
        type="primary"
        disabled={disabled}
        style={{ backgroundColor: tokens.colors.primary, border: tokens.colors.primary, marginRight: '70px' }}
        onClick={() => {
          onOk();
          isInttraConfirmation && updateInttraCodeInMasterData(inttraCode);
        }}>Next
      </Button>
    </div>;
  }

  closeViewBreakdown = () => {
    this.setState({ viewBreakdownVisible: false });
    this.decrementStepChange();
  }

  createBookingForFF = (visible) => {
    if (visible) {
      sendEvent(
        EventCategories.INQUIRY_BOOKING_FF,
        'Process Booking - Updated Cost Structure Next',
      );
    }
    this.setState({
      bookingFFModalVisible: visible,
      viewBreakdownVisible: false,
    });
    if (visible) {
      this.incrementStepChange();
    } else {
      this.decrementStepChange();
    }
  }

  incrementStepChange = () => {
    this.setState((state) => ({
      currentBookingStep: state.currentBookingStep + 1,
    }));
  };

  decrementStepChange = () => {
    this.setState((state) => ({
      currentBookingStep: state.currentBookingStep - 1,
    }));
  };

  handleEditINTTRACode = () => {
    const { newINTTRACode } = this.state;
    const { updateInttraCodeInMasterData } = this.props;
    this.setState({
      isEditINTTRACodeModalVisible: false,
      inttraCode: newINTTRACode,
    }, () => {
      updateInttraCodeInMasterData(newINTTRACode);
    });
  }

  renderINTTRAEditCodeModal = () => {
    const { isEditINTTRACodeModalVisible, inttraCode, isBooking } = this.state;
    const { classes } = this.props;
    return (
      <Modal
        visible={isEditINTTRACodeModalVisible}
        title="Edit"
        className={classes.editCodeModal}
        width={340}
        onCancel={() => {
          this.setState({
            isEditINTTRACodeModalVisible: false,
          });
        }}
        footer={
          <React.Fragment>
            <Button className={classes.cancelButton}
              onClick={() => {
                this.setState({
                  isEditINTTRACodeModalVisible: false,
                });
              }}
            >
              Cancel
            </Button>
            <Button className={classes.updateButton}
              onClick={() => {
                !isBooking && this.handleEditINTTRACode()
              }}
            >
              Update
            </Button>
          </React.Fragment>
        }
      >
        <span
          style={{ color: tokens.colors.textSecondary, fontSize: `${tokens.fontSize.small}px`, fontWeight: 600 }}
        >
          INTTRA Code*
        </span>
        <Input
          style={{ marginLeft: '16px', width: '60%' }}
          defaultValue={inttraCode}
          placeholder="INTTRA Code"
          onChange={e => this.setState({ newINTTRACode: e.target.value })}
        />
      </Modal>
    )
  }

  getFinalStepTitle = () => {
    const { bookingData } = this.props;
    if (this.isInttraBookingVisible()) return 'Confirmation';
    const trailerAndRoadModes = [InquiryModes.TRAILER, InquiryModes.DOMESTIC, InquiryModes.RPTL];
    if (trailerAndRoadModes.includes(bookingData?.bookingDetails?.mode)) return 'Add Booking Details';
    return 'Booking Note Upload';
  };

  renderBookingSteps = () => {
    const {
      currentBookingStep,
      inttraCode,
      isEditINTTRACodeModalVisible,
      bookingProcess,
      isBooking,
    } = this.state;
    const { classes, isAmend } = this.props;
    return (
      <div>
        <Steps
          current={currentBookingStep}
          className={classes.bookingSteps}
        >
          <Steps.Step
            title="Shipper Booking Details"
          />
          <Steps.Step
            title="Updated Cost Structure"
          />
          {this.isInttraBookingVisible() &&
            <Steps.Step
            title={
              <span>
                Process Booking
                {currentBookingStep !== 3 && !isAmend ?
                  <span className={classes.inttraIsLive}>
                    INTTRA Booking is live
                  </span> :
                  ((bookingProcess === BookingProcess.INTTRA || isAmend) &&
                    <div className={classes.inttraCodeEdit}>
                      INTTRA Code: <span style={{ fontWeight: 600 }}>{inttraCode}</span>
                      {!isAmend && <span
                        className={classes.editButton}
                        style={{ cursor: isBooking ? 'not-allowed' : 'pointer' }}
                        onClick={() => {
                          !isBooking && this.setState({
                            isEditINTTRACodeModalVisible: true,
                          })
                        }}
                      >Edit</span>}
                    </div>
                  )
                }
              </span>
            }
          />}
          <Steps.Step
            title={this.getFinalStepTitle()}
          />
        </Steps>
        {isEditINTTRACodeModalVisible && this.renderINTTRAEditCodeModal()}
      </div>
    );
  }

  isInttraBookingVisible = () => {
    const { showInttraBookingFF, bookingData, containersWithInttraBookingDisabled } = this.props;
    const carrierDetails = bookingData?.chargeDetails?.carrierDetails;
    const mode = bookingData?.bookingDetails?.mode;
    const isContainerWithInttraBookingDisabled = bookingData?.bookingDetails?.containerDetails?.some(container => (
      containersWithInttraBookingDisabled.some(item => (
        container.type === item.type && container.size === item.size
      ))
    ));

    return showInttraBookingFF && isValidString(carrierDetails?.scacCode) && mode === 'FCL'
      && !isContainerWithInttraBookingDisabled;
  };

  renderBookingFFModal = () => <BookingFFModal
    isVisible={this.state.bookingFFModalVisible}
    bookingId={this.props.cardData.id}
    bookingNumber={this.props.cardData.bookingNumber}
    handleBack={() => this.createBookingForFF(false)}
    type={'FF'}
    inquiryMode={this.props.bookingData.bookingDetails.mode}
    bookingData={this.props.bookingData}
    isProcessBookingForm={true}
    handleClose={this.props.handleCancel}
    isBooking={(isBooking) => {
      this.setState({ isBooking });
    }} />

  onProcessBookingBack = () => {
    this.decrementStepChange();
  }

  onProcessBookingNext = () => {
    this.incrementStepChange();
  }

  renderInttraCodeInput = () => {
    const { classes, isAmend } = this.props;
    const { inttraCode } = this.state;
    return (
      <div className={classes.inttraCode}>
        INTTRA Code
        <Input
          style={{ marginLeft: '12px', width: '50%' }}
          placeholder="Enter INTTRA Code"
          defaultValue={inttraCode}
          disabled={isAmend}
          onChange={e => this.setState({ inttraCode: e.target.value })}
        />
      </div>
    )
  }

  handleRequestInttraCode = async () => {
    this.setState({
      isRequestInttraRegistrationLoading: true,
    });
    const response = await requestInttraRegistrationEmail();
    if (response.isSuccess) {
      this.setState({
        protip: true,
        isRequestInttraRegistrationLoading: false,
      });
    } else {
      message.error(response.errorMessage);
      this.setState({
        isRequestInttraRegistrationLoading: false,
      });
    }
  }
  
  renderProcessBooking = () => {
    const { classes, isAmend } = this.props;
    const { bookingProcess, inttraCode, isRequestInttraRegistrationLoading } = this.state;
    const disabled = !bookingProcess || (bookingProcess === BookingProcess.INTTRA && !inttraCode);
    return (
      <React.Fragment>
        <div className={classes.processSelection}>
          {!isAmend && <div className={classes.selectionText}>
            We have integrated INTTRA to ease your booking.<br/>
            You can select INTTRA or choose to upload DO instead.
          </div>}
          <div style={{ marginTop: '23px', display: 'flex' }}>
            <span
              className={classes.selection}
              onClick={() => this.setState({ bookingProcess: BookingProcess.INTTRA })}
              style={{
                marginRight: '12px',
                border: bookingProcess === BookingProcess.INTTRA ?
                  `2px solid ${isAmend ? '#999999' : '#1875F0'}` : '1px solid #D9D9D9',
              }}
            >
              <img src={inttraLogo} style={{ marginBottom: '15px' }} />
              INTTRA
            </span>
            <span
              className={isAmend ? classNames(classes.selection, classes.disabledSelection)
                : classes.selection}
              onClick={() => {
                !isAmend && this.setState({ bookingProcess: BookingProcess.BOOKING_NOTE})
              }}
              style={{
                border: bookingProcess === BookingProcess.BOOKING_NOTE ? '2px solid #1875F0' : '1px solid #D9D9D9',
              }}
            >
              <img src={isAmend ? docUploadDisabled : documentUpload} style={{ marginBottom: '15px' }} />
              Upload Booking Note
            </span>
          </div>
          {bookingProcess === BookingProcess.INTTRA && this.renderInttraCodeInput()}
          {!this.props.inttraCode && 
            <div className={classes.requestInttraCode}>If INTTRA code is not available,&nbsp;
              <span
                className={classes.requestCode}
                onClick={() => {
                  this.handleRequestInttraCode()
                }}
              >Click here to request INTTRA registration.</span>
              {isRequestInttraRegistrationLoading && <Spin size="small" style={{ paddingLeft: '4px' }} />}
            </div>
          }
        </div>
        <div style={{ padding: '24px', borderTop: '1px solid rgb(151,151,151, 0.2)'  }}>
          {this.renderFooter(
            this.onProcessBookingBack,
            this.onProcessBookingNext,
            disabled,
            true,
          )}
        </div>
        {this.renderProtip()}
      </React.Fragment>
    );
  };

  renderProtip = () => {
    const { protip } = this.state;
    const { handleCancel } = this.props;
    return (
      protip && <Protip
      visible={protip}
      success={'Congrats'}
      message1={'You request for INTTRA registration has been successfully received. Please check your mail for further instructions.'}
      okay={'Okay'}
      onOkay={handleCancel}
    />
    );
  }

  renderINTTRAConfirmationModal = () => {
    const { bookingData, cardData, isAmend, isCreateNew, isRetryInttraRequest,
      handleCloseSideDrawer, handleCancel } = this.props;
    return (
      <INTTRABookingConfirmationModal
        bookingData={bookingData}
        handlePrevious={() => {
          this.decrementStepChange();
        }}
        type={'FF'}
        isBooking={(isBooking) => {
          this.setState({ isBooking });
        }}
        bookingId={cardData.id}
        isAmend={isAmend}
        isCreateNew={isCreateNew}
        isRetryInttraRequest={isRetryInttraRequest}
        handleCloseBookingModal={handleCancel}
        handleCloseSideDrawer={handleCloseSideDrawer}
      />
    );
  };

  renderAddTruckingDetails = () => {
    const { cardData, handleCancel } = this.props;
    return (
      <AddTruckingBookingDetails
        handlePrevious={() => {
          this.decrementStepChange();
        }}
        type={'FF'}
        isBooking={(isBooking) => {
          this.setState({ isBooking });
        }}
        bookingId={cardData.id}
        handleClose={handleCancel}
      />
    );
  };

  renderProcessBookingData = () => {
    const { bookingData } = this.props;
    if (this.isInttraBookingVisible()) return this.renderProcessBooking();
    if ([InquiryModes.TRAILER].includes(bookingData?.bookingDetails?.mode)) return this.renderAddTruckingDetails();
    return this.renderBookingFFModal();
  }

  render() {
    const { bookingId, visible, classes } = this.props;
    const { currentBookingStep, bookingProcess, isBooking } = this.state;
    const currentBookingStepMap = bookingStepsMap(this.isInttraBookingVisible());
    return <Modal
      className={classes.modal}
      closable={true}
      onCancel={!isBooking && this.props.handleCancel}
      footer={false}
      visible={visible}
      title={`Process Booking #${bookingId}`}>
        {this.renderBookingSteps()}
      {currentBookingStep === currentBookingStepMap.SHIPPER_BOOKING_DETAILS && (
        <React.Fragment>
          <div style={{ padding: '24px' }}>
            <CreateEnquiryDetails
              className={classes.cardToDiv}
              bookingData={this.props.bookingData}
              booking={true} />
          </div>
          <div style={{ padding: '24px', borderTop: '1px solid rgb(151,151,151, 0.2)', marginTop: '12px' }}>
            {this.renderFooter(this.props.handleCancel, this.createBooking)}
          </div>
        </React.Fragment>
      )}
      {(currentBookingStep === currentBookingStepMap.UPDATED_COST_STRUCTURE) &&
        <ViewBreakdown
          type={'FF'}
          booking={true}
          bidId={this.props.bookingData.chargeDetails.id}
          inquiryId={this.props.bookingData.chargeDetails.objectId}
          chargeDetails={this.props.bookingData.chargeDetails}
          visible={this.state.viewBreakdownVisible}
          handleCancel={this.closeViewBreakdown}
          createBooking={() => this.createBookingForFF(true)}
          isUpdatedCostStructure={true}
          heading="Updated Cost Structure"
          isProcessBookingForm={true}
          inquiryData={this.props.bookingData?.bookingDetails}
        />}
      {(currentBookingStep === currentBookingStepMap.PROCESS_BOOKING && (
        this.renderProcessBookingData()
      ))}
      {this.isInttraBookingVisible() && (currentBookingStep === currentBookingStepMap.CONFIRMATION && (
        bookingProcess === BookingProcess.INTTRA ?
        this.renderINTTRAConfirmationModal() : this.renderBookingFFModal()
      ))}
    </Modal>;
  }
}

const mapStateToProps = ({ masterData }, ownProps) => ({
  showInttraBookingFF: masterData.modules.show_inttra_booking_ff,
  inttraCode: masterData.inttraCode,
  containersWithInttraBookingDisabled: masterData.bookingMasterData.containersWithInttraBookingDisabled,
});

const mapDispatchToProps = dispatch =>
  bindActionCreators({
    updateInttraCodeInMasterData,
  },
  dispatch,
);

export default connect(mapStateToProps, mapDispatchToProps)(injectSheet(styles)(BookingDetail));
